<template>
  <v-container fluid>
    <PageTitle title="Messaging Events" />

    <ApiDataTable
      ref="api_table"
      data-api="messaging"
      :can-insert="false"
      :can-update="false"
      :can-delete="true"
      :toolbar-buttons="toolbarButtons"
      @toolbar-button-click="toolbarButtonClick"
      :row-buttons="rowButtons"
      @row-button-click="rowButtonClick"
    />

    <v-dialog v-model="formDialog" scrollable width="800">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="formValid">
            <v-container>
              <v-row>
                <v-col>
                  <TextBox
                    v-model="edtItem.methodName"
                    :config="{ title: 'Event Name', isRequired: true }"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <ScriptEditor name="Action" v-model="edtItem.mapEventName" :json="true" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="save" :disabled="!formValid"
            >Save</v-btn
          >
          <v-btn text color="error" @click="formDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiDataTable from "../ui/shared/ApiDataTable.vue";
import TextBox from "../ui/controls/TextBox.vue";
import server from "../../services/server.js";
import PageTitle from "../ui/shared/PageTitle.vue";
import ScriptEditor from "../ui/designer/ScriptEditor.vue";

export default {
  name: "NotificationMethods",

  components: { ApiDataTable, TextBox, PageTitle, ScriptEditor },

  data() {
    return {
      toolbarButtons: [{ title: "Add New Event", icon: "mdi-plus" }],
      rowButtons: [{ title: "Edit", icon: "mdi-square-edit-outline" }],
      formDialog: false,
      loading: false,
      edtItem: {},
      formValid: false,
      formTitle: "",
    };
  },

  methods: {
    toolbarButtonClick() {
      this.formTitle = "Add New Event";
      this.edtItem = {
        id: 0,
      };
      this.formDialog = true;
    },
    rowButtonClick({ item }) {
      server.get("messaging/" + item.id).then((result) => {
        this.formTitle = "Edit Event";
        this.edtItem = Object.assign({}, result);
        this.formDialog = true;
      });
    },
    save() {
      this.loading = true;

      if (this.edtItem.id == 0) {
        server.post("messaging", this.edtItem).then(
          () => {
            this.loading = false;
            this.formDialog = false;
            this.$refs.api_table.refresh(true);
          },
          (err) => {
            this.loading = false;
            alert(err);
          }
        );
      } else {
        server.put("messaging", this.edtItem.id, this.edtItem).then(
          () => {
            this.loading = false;
            this.formDialog = false;
            this.$refs.api_table.refresh(true);
          },
          (err) => {
            this.loading = false;
            alert(err);
          }
        );
      }
    },
  },
};
</script>